import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Es difícil de usar?',
    a: "No. Es un manual de 'haz clic aquí y pega esto allá'. Cero jerga técnica."
  }, {
    q: '¿Sirve para mi nicho?',
    a: 'Si educas, vendes o informas, este lenguaje visual funciona para ti.'
  }, {
    q: '¿Tengo que pagar por IAs caras?',
    a: 'El manual incluye opciones gratuitas y premium. Tú decides cuánto invertir.'
  }, {
    q: '¿Realmente solo cuesta $6.36?',
    a: 'Sí. Es el precio de tu compromiso hoy. Sin letras pequeñas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-800 border-y border-white/5" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <div className="text-center mb-8 md:mb-16" data-id="element-15">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-3 md:mb-4" data-id="element-16">
            Preguntas Frecuentes
          </h2>
          <div className="h-1 w-20 bg-gold-500 mx-auto rounded-full" data-id="element-17"></div>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <div key={index} className="bg-navy-900 rounded-xl border border-white/5 overflow-hidden" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-4 md:px-6 md:py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-20">
                <span className="font-serif font-bold text-base md:text-lg text-white pr-4" data-id="element-21">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
              </button>
              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-24">
                    <div className="px-4 pb-4 md:px-6 md:pb-5 text-gray-300 font-light text-sm md:text-base border-t border-white/5 pt-3 md:pt-4" data-id="element-25">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}